const LOGO_TEXT = 'BEAM MONSTER';

export { LOGO_TEXT };
